import { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import { playBajajSound, stopBajajSound } from "../utils/audio";
import { sendMessageToWebSocket } from "../services/ws-config";



export const AmountChoice = ({ value, selected, onClick , disabled }) => (
    <button
      className={`amount-choice${selected ? " selected" : ""}`}
      onClick={() => onClick(value)}
      type="button"
      disabled={disabled}
    >
      {value}
    </button>
  );
  
  // Improved, Antd-powered, Clean, Responsive BetComponent
  export function BetComponent({ winDisplayOpen, setWinDisplayOpen , multiplier , 
    setMultiplier , startGame , setStartGame , betAmount , setBetAmount , setCashoutMultiplier , balanceDisplayOpen, setBalanceDisplayOpen, balance, setBalance, totalWin, 
    setTotalWin, isCrashed, betHistory, setBetHistory, crashMultiplier, setCrashMultiplier }) {
    const [amount, setAmount] = useState(50); // Default
    const [input, setInput] = useState("50");
    const [mode, setMode] = useState("basic"); // bet/auto
    const [autoCashoutEnabled, setAutoCashoutEnabled] = useState(false);
    const [autoCashoutMultiplier, setAutoCashoutMultiplier] = useState(1.00);
    const [gameState, setGameState] = useState("bet"); // bet/playing
  
    const choices = [50, 100, 200, 500];
  
    function handleInput(e) {
      // Allow only numbers (strip non-digits)
      const val = e.target.value.replace(/\D/, "");
      if(val > 500){
        setInput("500");
        setAmount(500);
        return;
      }

      if(val < 50){
        setInput("50");
        setAmount(50);
        return;
      }
      setInput(val);
      if (val) setAmount(Number(val));
    }
  
    function handleAmountClick(val) {
      setAmount(val);
      setInput(String(val));
    }
  
    function handleModeChange(mode) {
      setMode(mode);
    }
  
    function handleAutoCashoutMultiplierChange(e) {
      setAutoCashoutMultiplier(e.target.value);
    }
  
    function handleAutoCashoutChange(e) {
      setAutoCashoutEnabled(e.target.checked);
    }
  
    function handleBet() {
      // Betting callback, to be wired up.
      //alert(`Bet placed: ${mode} | Amount: ${amount} Birr`);
      if (gameState === "bet") {
        if(balance < amount){
          setBalanceDisplayOpen(true);
          return;
        }
        else{
          setBalance(balance - amount);
        }
        // Generate random crash multiplier between 1.00x and 50.00x with 3% house edge
        const randomValue = Math.random();
        const houseEdge = 0.97; // 3% house edge means 97% RTP
        const maxMultiplier = 50;
        
        // Using exponential distribution for crash point
        // This creates a realistic crash game distribution where lower multipliers are more common
        const crashPoint = Math.max(1.00, Math.min(maxMultiplier, (1 / (1 - randomValue * houseEdge))));
        setCrashMultiplier(parseFloat(crashPoint.toFixed(2)));
        
        setGameState("playing");
        setStartGame(true);
        setBetAmount(amount);
         
        
      } else {
        setGameState("bet");
        setWinDisplayOpen(true);
        setStartGame(false);
        stopBajajSound();
        setCashoutMultiplier(multiplier);
        setBalance(parseFloat((balance + (amount * multiplier)).toFixed(2)));
        setBetHistory([...betHistory, {date: new Date().toLocaleString(), bet: amount, multiplier: multiplier , win: multiplier * amount}]);
      }
    }


    useEffect(() => {
      if(isCrashed){
        setGameState("bet");
        //setStartGame(false);
        stopBajajSound();
      }
    }, [isCrashed]);


    useEffect(() => {
      if(multiplier >= autoCashoutMultiplier && autoCashoutEnabled){
        setGameState("bet");
        setWinDisplayOpen(true);
        setStartGame(false);
        stopBajajSound();
        setCashoutMultiplier(multiplier);
        setBalance(balance + (amount * multiplier));
      }
    }, [multiplier]);


  
    return (
      <div className="bet-container-clean">
        <Row justify="center" className="bet-modes-row">
          <Col>
            <button
              className={`bet-mode-clean${mode === "basic" ? " active" : ""}`}
              type="button"
              onClick={() => handleModeChange("basic")}
            >
              Bet
            </button>
          </Col>
          <Col>
            <button
              className={`bet-mode-clean${mode === "auto" ? " active" : ""}`}
              type="button"
              onClick={() => handleModeChange("auto")}
            >
              Auto
            </button>
          </Col>
        </Row>
        <Row style={{ width: "100%" }} align="middle">
          <Col xs={0} sm={2} md={2} lg={3} xl={5} xxl={5} >
           
          </Col>
          <Col xs={12} sm={10} md={10} lg={9} xl={7} xxl={7}>
          
            <Row style={{ width: "100%" }} align="middle">
                <button
                  type="button"
                  className="amount-adjust-btn minus-btn"
                  disabled={gameState === "playing"}
                  
                  onClick={() => {
                    const newVal = Math.max(1, (Number(input) || 1) - 1);
                    if(newVal < 50){
                      setInput("50");
                      setAmount(50);
                      return;
                    }
                    setInput(String(newVal));
                    setAmount(newVal);
                  }}
                  tabIndex={-1}
                >
                  −
                </button>
                <input
                  type="number"
                  value={input}
                  max={500}
                  min={1}
                  className="amount-input-clean"
                  onChange={handleInput}
                  placeholder="የትክክለኛ መጠን"
                  disabled={gameState === "playing"}

                  
                />
                <button
                  type="button"
                  className="amount-adjust-btn plus-btn"
                  disabled={gameState === "playing"}
                  onClick={() => {
                    const newVal = (Number(input) || 0) + 1;
                    if(newVal > 500){
                      setInput("500");
                      setAmount(500);
                      return;
                    }
                    setInput(String(newVal));
                    setAmount(newVal);
                  }}
                  tabIndex={-1}
                >
                  +
                </button>
            </Row>
            <Row className="amount-choices-row" gutter={[4, 4]}>
              {choices.map(val => (
                <Col key={val} span={12}>
                  <AmountChoice
                    value={val}
                    selected={amount === val}
                    disabled={gameState === "playing"}
                    onClick={handleAmountClick}
                  />
                </Col>
              ))}
            </Row>
          </Col>
          
          <Col xs={12} sm={10} md={10} lg={9} xl={7} xxl={7} style={{ width: "100%" }} align="middle">
            <button 
              className="big-bet-btn-clean" 
              type="button" 
              onClick={handleBet}
              disabled={isCrashed}
              style={{
                backgroundColor: gameState === "playing" ? "#ff8c00" : undefined
              }}
            >
              {gameState === "playing" ? (
                <>
                  Cashout <br />
                  <span style={{ marginTop: "5px", fontSize: "1.1rem", fontWeight: 400, color: "#eee" }}>
                    {(amount * multiplier).toFixed(2)} Br
                  </span>
                </>
              ) : (
                <>
                  Start <br />
                  <span style={{ marginTop: "5px", fontSize: "1.1rem", fontWeight: 400, color: "#eee" }}>
                    {amount} Br
                  </span>
                </>
              )}
            </button>
          </Col>
        </Row>
        {/* Show the following row only if "auto" mode is selected */}
        {mode === "auto" && (
          <Row align="middle" style={{ marginTop: 15, marginBottom: 5 , width: "100%" , justifyContent: "center" }}>
            <Col flex="none">
              <span style={{ fontSize: "1rem", color: "#ccc", display: "flex", alignItems: "center" }}>
                Auto cashout
                <button
                  type="button"
                  aria-pressed={autoCashoutEnabled}
                  onClick={() => setAutoCashoutEnabled(!autoCashoutEnabled)}
                  tabIndex={0}
                  style={{
                    marginLeft: 9,
                    width: 28,
                    height: 28,
                    background: autoCashoutEnabled ? "#2ecc40" : "#222328",
                    border: "none",
                    borderRadius: 7,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "background 0.15s",
                    border : "1px solid #333",
                  }}
                >
                  {autoCashoutEnabled ? (
                    // Green check
                    <svg width="17" height="17" viewBox="0 0 17 17" style={{ display: "block" }}>
                      <polyline
                        points="3.5,8.5 7.3,13 13.5,4"
                        style={{
                          fill: "none",
                          stroke: "white",
                          strokeWidth: 2.6,
                          strokeLinecap: "round",
                          strokeLinejoin: "round"
                        }}
                      />
                    </svg>
                  ) : (
                    // Empty box or gray check
                    <svg width="23" height="23" viewBox="0 0 23 23" style={{ display: "block" }}>
                      <rect x="2" y="2" width="19" height="19" rx="4" fill="#444" />
                    </svg>
                  )}
                </button>
              </span>
            </Col>
            <Col flex="none" style={{ marginLeft: 8 }}>
              <input
                type="number"
                min={1.01}
                step="0.1"
                value={autoCashoutMultiplier}
                disabled={!autoCashoutEnabled}
                onChange={e => setAutoCashoutMultiplier(e.target.value)}
                style={{
                  width: 65,
                  fontSize: "1rem",
                  padding: "3px 7px",
                  borderRadius: 7,
                  border: "1px solid #555",
                  background: "#1b1b1e",
                  color: autoCashoutEnabled ? "#e4e4ee" : "#555"
                }}
                placeholder="e.g. 2.00"
              />
              <span style={{ marginLeft: 3, color: "#aaa", fontSize: "0.99rem" }}>x</span>
            </Col>
          </Row>
        )}
        <style>{`
          .bet-container-clean {
            background: #222;
            border-radius: 21px 21px 21px 21px;
            padding: 18px 20px 14px 20px;
            min-width:0;
            max-width: 100%;
            width:100%;
            margin-bottom:5px;
            box-shadow: 0 0 14px #0007;
          }
          .bet-modes-row {
            justify-content: center !important;
            margin-bottom: 12px;
            gap: 1px;
            width: 100%;
          }
          .bet-mode-clean {
            background: #111;
            border: 2.5px solid #111;
            color: #999;
            width: 100px;
            border-radius: 10px;
            padding: 3.5px 22px 3.5px 22px;
            font-size: .8rem;
            font-weight: 500;
            cursor: pointer;
            margin: 0 2px;
            transition: all 0.16s;
            letter-spacing: 1px;
          }
          .bet-mode-clean.active {
            background: #444;
            color: #ddd;
            border: 2.5px solid #444;
          }
          .bet-bottom-row {
            width: 100%;
            margin-top: 2px;
            align-items: flex-end;
          }
          @media (max-width: 700px) {
            .bet-bottom-row {
              flex-direction: column;
              gap: 10px;
            }
            .bet-container-clean {
              padding: 12px 4vw 10px 4vw;
            }
          }
          .amount-choices-row {
            max-width: 165px;
          }
          .amount-choice {
            background: #191922;
            color: #aaa;
           
            border-radius: 8px;
            padding-top: 4px;
            padding-bottom: 4px;
            padding-left: 15px;
            padding-right: 15px;
            font-size: 1rem;
            font-weight: 600;
            width : 80px;
            cursor: pointer;
            transition: all .15s;
          }
          .amount-choice.selected, .amount-choice:active {
            background: #191922;
            color: #aaa;
            
          }
          .amount-input-clean {
            font-size: 1rem;
            border-radius: 8px;
            border: 1px solid #333;
            background: #181c22;
            margin-bottom: 5px;
            margin-left: 2.5px;
            margin-right: 2.5px;
            color: #fff;
            font-weight: 600;
            width: 95px;
            text-align: center;
            padding: 6px 13px;
            box-sizing: border-box;
            outline: none;
            transition: border .14s;
          }
          .amount-input-clean:focus {
            
          }
          .amount-adjust-btn {
            background: #191922;
            color: #aaa;
            border: 1px solid #333;
            border-radius: 8px;
            padding: 4px 10px;
            height: 30px;
            margin-bottom: 5px;
            font-size: 1rem;
            font-weight: 600;
          }
          .amount-adjust-btn:hover {
            background: #222;
            color: #ddd;
            border: 1px solid #444;
          }
          .big-bet-btn-clean {
            background: #28A909;
            color: #fff;
            font-size:1.4rem;
            font-weight: 500;
            font-family: 'roboto', sans-serif;
            letter-spacing: 1.3px;
            box-shadow: 0 2px 12px #0005;
            border: none;
            border-radius: 13px;
            padding: 15px 32px 13px 32px;
            cursor:pointer;
            width: 90%;
            transition: background .16s, filter .13s, color .12s;
            margin: 0;
            height: 90px;
          }
          .big-bet-btn-clean:hover {
            background: #30b855;
            filter: brightness(1.06);
            color: #fff;
          }
        `}</style>
      </div>
    );
  }